import BaseModule from '@/store/baseModule';
import BaseModulePlugins from '@/store/baseModule/plugins';
import { formatDateToInputDate } from '@/business/utils/dates';
import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import registerTabModule from '@/store/TabModule';
import registerLightDeadlines from '@/store/modules/actions/lightDeadlines';
import registerLightPriorities from '@/store/modules/actions/lightPriorities';
import registerLightTypes from '@/store/modules/actions/lightTypes';
import registerLightGain from '@/store/modules/actions/lightGain';
import registerLightActionplan from '@/store/modules/actionplans/light';
import registerActionPlans from './actionPlans';
import registerActionPriorities from './actionPriorities';
import registerActionTypes from './actionTypes';
import registerDeadlines from './deadlines';
import registerActionGain from './actionGain';
import delayed from './delayed';

const dateFilter = new Date();
dateFilter.setDate(new Date().getDate() - 14);

const attributesObjRef = {
  ended_limit: {
    type: '$endedLimit',
    values: [],
    noFilter: true,
    serverSide: true,
  },
  entity_nav_full_id: {
    type: '$instr',
    values: [],
    noFilter: true,
    serverSide: true,
  },
  staffs_in_charge_id: {
    type: '$instr',
    values: [],
    noFilter: true,
    serverSide: true,
  },
};
const attributesObj = {
  ended_limit: {
    type: '$endedLimit',
    values: [formatDateToInputDate(dateFilter)],
  },
  entity_nav_full_id: {
    type: '$instr',
    values: [],
  },
  action_status_id: {
    type: '$instr',
    values: [],
  },
  action_plan_status: {
    type: '$instr',
    values: [],
  },
  staffs_in_charge_id: {
    type: '$instr',
    values: [],
  },
};

export default (store) => {
  store.registerModule(
    ['dashboardPem'],
    new BaseModule({
      serviceAPI: {},
      attributesObj,
      attributesObjRef,
      makeQueryParams: makeListRequest({}),
      hasDefaultFilters: true,
      customActions: {
        initItems: ({ commit }) => {
          commit('SET_ITEMS', null);
        },
      },
    })
  );

  const basePlugin = new BaseModulePlugins({
    module: 'dashboardPem',
    store,
  });

  basePlugin.addItemsToAttributesObjRefWhenTheyAreLoaded({
    serverSide: true,
    autocomplete: true,
    attribute: 'action_status_id',
    filter: 'actions/status',
  });

  basePlugin.addItemsToAttributesObjRefWhenTheyAreLoaded({
    serverSide: true,
    autocomplete: true,
    attribute: 'action_plan_status',
    filter: 'actionplans/status',
  });
  store.dispatch('dashboardPem/refreshItems');

  delayed(store, () => {
    registerActionPlans(store);
    registerDeadlines(store);
    registerActionPriorities(store);
    registerActionTypes(store);
    registerActionGain(store);
    registerLightDeadlines(store);
    registerLightPriorities(store);
    registerLightTypes(store);
    registerLightGain(store);
    registerLightActionplan(store);
    store.subscribe((mutation) => {
      if (mutation.type === 'entities/SET_CURRENT') {
        store.dispatch('dashboardPem/setFilterAttribute', {
          attribute: 'entity_nav_full_id',
          values: [],
          useDelay: true,
        });
        store.commit('dashboardPem/SET_ITEMS', null);
      }
    });
    store.subscribeAction((action) => {
      if (action.type === 'dashboardPem/refreshItems') {
        store.dispatch('dashboardPem/actionPlans/refreshItems');
        store.dispatch('dashboardPem/deadlines/refreshItems');
        store.dispatch('dashboardPem/actionPriorities/refreshItems');
        store.dispatch('dashboardPem/actionTypes/refreshItems');
        store.dispatch('dashboardPem/actionGain/refreshItems');
      } else if (action.type === 'dashboardPem/setFilterAttribute') {
        if (action.payload.attribute === 'action_plan_status') {
          store.dispatch('dashboardPem/actionPlans/setFilterAttribute', {
            ...action.payload,
            attribute: 'action_plan_status_id',
          });
        } else {
          store.dispatch(
            'dashboardPem/actionPlans/setFilterAttribute',
            action.payload
          );
        }
        store.dispatch(
          'dashboardPem/deadlines/setFilterAttribute',
          action.payload
        );
        store.dispatch(
          'dashboardPem/actionPriorities/setFilterAttribute',
          action.payload
        );
        store.dispatch(
          'dashboardPem/actionTypes/setFilterAttribute',
          action.payload
        );
        store.dispatch(
          'dashboardPem/actionGain/setFilterAttribute',
          action.payload
        );
      }
    });
    if (store.getters['entities/current']) {
      store.dispatch('dashboardPem/refreshItems');
    }
  });

  registerTabModule({
    namespace: ['dashboardPem', 'table'],
    tabs: [
      '',
      'actionplans/light',
      'actions/lightDeadlines',
      'actions/lightPriorities',
      'actions/lightTypes',
      'actions/lightGain',
    ],
    store,
  });
};
